export const isValidResponse = (response: { [key: string]: any }, properties: Array<string>) => (
  properties.every((property) => response[property])
);
